import React from "react";
import { createChatBotMessage } from "react-chatbot-kit";
import Options from "../botcomponents/Options/Options";
//import Quiz from "../components/Quiz/Quiz";

import chatbot2 from "../../ChatBot/img/chatbot5.gif";

import soniconline from "../../ChatBot/img/sonic-online.png";

import "../bot/config.css";

import "../../../index.css";

import ContactUs from "../botcomponents/ContactUs/ContactUs";
import Food from "../botcomponents/Food/Food";

const botNameDef = "Rachit | Sonic Bot";

const config = {
  botName: "Sonic Bot",
  customStyles: {
    botMessageBox: {
      backgroundColor: "#26c6da",
    },
    chatButton: {
      backgroundColor: "#5ccc9d",
    },
  },
  customComponents: {
    // Replaces the default header
    header: () => (
      <div
        style={{
          backgroundColor: "#7cdce8",
          color: "#FFFFFF",
          height: "60px",
          fontStyle: "inherit",
          fontSize: "20px",
          padding: "10px",
        }}
      >
        <div style={{ paddingTop: "1px" }}>{botNameDef}</div>
        <div style={{ right: "7%" }}>
          <img src={soniconline} alt="online" width="11" height="10" />
          <text style={{ fontSize: "10px", lineHeight: "19px" }}> Online</text>
        </div>
      </div>
    ),
    botAvatar: (props) => (
      <img
        className="avtar"
        src={chatbot2}
        alt="Girl in a jacket"
        width="40"
        height="40"
      />
    ),
  },
  initialMessages: [
    createChatBotMessage(
      `Welcome to Sonic Bot...Designed by Rachit. How may I help you?`
    ),
    createChatBotMessage(
      `👋 Hi​! I'm a Sonic Bot. Select the topic or write your question below:👇`,
      {
        widget: "options",
      }
    ),
  ],
  widgets: [
    {
      widgetName: "options",
      widgetFunc: (props) => <Options {...props} />,
    },
    {
      widgetName: "contactUs",
      widgetFunc: (props) => <ContactUs {...props} />,
    },
    {
      widgetName: "food",
      widgetFunc: (props) => <Food {...props} />,
    },
  ],
};

export default config;
